// Build-time flag; window.__RUNTIME_ENV__ kept for parity with cyberjob_client, unused here.
const runtimeValue = (typeof window !== 'undefined' && window.__RUNTIME_ENV__?.SCORING_ENABLED)
    || process.env.REACT_APP_SCORING_ENABLED;

export const SCORING_ENABLED = runtimeValue === 'true' || runtimeValue === '1';
